export enum ScenarioActiveOption {
  StatusAndAlarms = 0,
  AlarmsOnly = 1,
  StatusOnly = 2,
}
